import React from 'react';
import { Avatar, Cell } from '@carnica/ui-kit';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
var cnSelectedAccount = cnBem('selected-account', styles);
export var SelectedAccount = function SelectedAccount(_ref) {
  var account = _ref.account,
    isOpen = _ref.isOpen;
  return /*#__PURE__*/React.createElement("div", {
    className: cnSelectedAccount({
      faded: isOpen
    }),
    "data-t-id": "components-SelectedAccount"
  }, /*#__PURE__*/React.createElement(Cell, {
    className: cnSelectedAccount(null, ['information']),
    leftSide: /*#__PURE__*/React.createElement(Avatar, {
      image: account === null || account === void 0 ? void 0 : account.avatar,
      size: "l"
    }),
    subTitle: account === null || account === void 0 ? void 0 : account.nickname,
    title: (account === null || account === void 0 ? void 0 : account.formattedAccountNumber) || (account === null || account === void 0 ? void 0 : account.formattedNumber)
  }));
};